<input
  title="Search"
  type="text"
  [value]="currentSearchTerm()"
  (input)="onSearchInput($event)"
  [placeholder]="'common.searchPlaceholder' | translate"
  class="border bg-white text-cmi-gray border-gray-300 rounded-md p-2 w-full" />
